import paths from "@icarius-router/paths";
import { getLocalizedString } from "@icarius-localization/strings";
import {
    dateClassRule,
    dateFormatter,
    dateValueGetter,
    dateFilterParams,
    dateComparator,
} from "@icarius-table/date";

export default () => [
    {
        pages: [paths.evaluationProcessDefinitionAssignment],
        config:
        {
            field: "Código de empleado",
            headerName: getLocalizedString("evaluatedCode"),
            filter: "agTextColumnFilter",
            checkboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
            enableRowGroup: true,
        }
    },
    {
        pages: [paths.evaluationProcessDefinitionAssignment],
        config:
        {
            field: "Apellido y nombres",
            headerName: getLocalizedString("evaluatedFullNamePlural"),
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.evaluationProcessDefinitionAssignment],
        config:
        {
            headerName: getLocalizedString("state"),
            field: "Estado",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.evaluationProcessDefinitionAssignment],
        config:
        {
            headerName: getLocalizedString("incomeDate"),
            field: "Fecha de contratación",
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
        }
    },
    {
        pages: [paths.evaluationProcessDefinitionAssignment],
        config:
        {
            field: "Tipo de formulario",
            headerName: getLocalizedString("evaluationType"),
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.evaluationProcessDefinitionAssignment],
        config:
        {
            field: "Evaluador del tipo de formulario",
            headerName: getLocalizedString("evaluator"),
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.evaluationProcessDefinitionAssignment],
        config:
        {
            field: "Cargo del evaluador",
            headerName: getLocalizedString("evaluatorPosition"),
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.evaluationProcessDefinitionAssignment],
        config:
        {
            field: "Grupo de cargo del evaluado",
            headerName: getLocalizedString("positionGroupOfEvaluated"),
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.evaluationProcessDefinitionAssignment],
        config:
        {
            field: "Cargo del evaluado",
            headerName: getLocalizedString("assessedPosition"),
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.evaluationProcessDefinitionAssignment],
        config:
        {
            field: "Gerencia del evaluado",
            headerName: getLocalizedString("evaluatedManager"),
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.evaluationProcessDefinitionAssignment],
        config:
        {
            field: "Función del evaluado",
            headerName: getLocalizedString("evaluatedFunction"),
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.evaluationProcessDefinitionAssignment],
        config:
        {
            field: "Centro de costo de gestión del evaluado",
            headerName: getLocalizedString("evaluatedCostCenterManagement"),
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.evaluationProcessDefinitionAssignment],
        config:
        {
            field: "Diseño del formulario",
            headerName: getLocalizedString("formDesign"),
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["evaluationProcessDefinitionAssignmentUserSelection"],
        config: {
            headerName: getLocalizedString("employeeCode"),
            field: "CODIGO DE EMPLEADO",
            filter: "agTextColumnFilter",
            chartDataType: "series",
            checkboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
            enableRowGroup: true,
        }
    },
    {
        pages: ["evaluationProcessDefinitionAssignmentUserSelection"],
        config:
        {
            headerName: getLocalizedString("nameAndSurname"),
            field: "APELLIDO Y NOMBRE",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ["evaluationProcessDefinitionAssignmentUserSelection"],
        config:
        {
            headerName: getLocalizedString("state"),
            field: "ESTADO",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["evaluationProcessDefinitionAssignmentUserSelection"],
        config:
        {
            headerName: getLocalizedString("icariusAccess"),
            field: "HABILITAR EL ACCESO A ICARIUS",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["evaluationProcessDefinitionAssignmentUserSelection"],
        config: {
            headerName: getLocalizedString("incomeDate"),
            field: "FECHA DE INGRESO",
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
        }
    },
    {
        pages: ["evaluationProcessDefinitionAssignmentUserSelection"],
        config: {
            headerName: getLocalizedString("position"),
            field: "CARGO",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["evaluationProcessDefinitionAssignmentUserSelection"],
        config: {
            headerName: getLocalizedString("jobGroupForEvaluation"),
            field: "GRUPO EVALUACIÓN DEL CARGO",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["evaluationProcessDefinitionAssignmentUserSelection"],
        config: {
            headerName: getLocalizedString("specificCompetencyGroupForPosition"),
            field: "GRUPO COMPETENCIAS ESPECÍFICAS CARGO",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["evaluationProcessDefinitionAssignmentUserSelection"],
        config: {
            headerName: getLocalizedString("function"),
            field: "FUNCIÓN",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["evaluationProcessDefinitionAssignmentUserSelection"],
        config: {
            headerName: getLocalizedString("fType"),
            field: "TIPO DE FUNCIONARIO",
            filter: "agSetColumnFilter",
            chartDataType: "series",
            enableRowGroup: true,
            enableValue: true,
        }
    },
    {
        pages: ["evaluationProcessDefinitionAssignmentUserSelection"],
        config: {
            headerName: getLocalizedString("jobLocation"),
            field: "LUGAR DE TRABAJO",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["evaluationProcessDefinitionAssignmentUserSelection"],
        config: {
            headerName: getLocalizedString("filterObra o Faena"),
            field: "OBRA O FAENA",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["evaluationProcessDefinitionAssignmentUserSelection"],
        config: {
            headerName: getLocalizedString("costCenter"),
            field: "CENTRO DE COSTO",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["evaluationProcessDefinitionAssignmentUserSelection"],
        config: {
            headerName: getLocalizedString("plantPersonnel"),
            field: "PERSONAL DE PLANTA",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["evaluationProcessDefinitionAssignmentUserSelection"],
        config: {
            headerName: getLocalizedString("management"),
            field: "GERENCIA",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["evaluationProcessDefinitionAssignmentUserSelection"],
        config: {
            headerName: getLocalizedString("department"),
            field: "DEPARTAMENTO",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["evaluationProcessDefinitionAssignmentUserSelection"],
        config: {
            headerName: getLocalizedString("section"),
            field: "SECCION",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["evaluationProcessDefinitionAssignmentUserSelection"],
        config: {
            headerName: getLocalizedString("jornadaType"),
            field: "TIPO DE JORNADA",
            filter: "agSetColumnFilter",
        }
    },
]